module.exports = __webpack_public_path__ + "static/media/Photo2.63ac2230.jpg";